import React, { useCallback, useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { orderValidator } from '../../../service/validatorForms';
import './ScrapOrderForm.css';
import DashboardContext from '../../context/dashboardContext';
import { getUserByMobileNumber } from '../../../service/userService';
import { Button, ButtonGroup, Collapse } from 'react-bootstrap';
import priceFormat from '../../../utils/showPriceFormat';
import { createScrapOrder } from '../../../service/orderService';
import { digitsArToEn, digitsFaToEn } from '@persian-tools/persian-tools';

const ScrapOrderForm = () => {

    const [userMobileNumber, setUserMobileNumber] = useState('');
    const [user, setUser] = useState();
    const [price, setPrice] = useState('');
    const [telephone, setTelephone] = useState('');
    const [address, setAddress] = useState('');
    const [userLoading, setUserLoading] = useState(false);
    const [loadingSpinner, setLoadingSpinner] = useState(false);
    const [transferType, setTransferType] = useState('wallet');
    const [description, setDescription] = useState('');

    const [, setForceUpdate] = useState();
    const forceUpdate = useCallback(() => setForceUpdate({}), []);

    const validatorRef = useRef(orderValidator());
    const {addToast} = useToasts();
    const history = useHistory();
    const dashContext = useContext(DashboardContext);
    
    
    const submitHandler = async (event) => {
        event.preventDefault();
        try {
            if (validatorRef.current.allValid()) {
                const newOrder = {
                    customer: {
                        fullName: user.fullName,
                        mobileNumber: user.mobileNumber,
                        telephone: telephone,
                        address: address,
                    },
                    orderType: 'scrap',
                    transferType: transferType,
                    price: Number(price),
                    description: description,
                }
                setLoadingSpinner(true);

                const { status, data } = await createScrapOrder(newOrder);
                if (status === 201) {
                    addToast("سفارش جدید با موفقیت شد", {
                        appearance: 'success',
                        autoDismiss: true,
                    })
                    dashContext.setOrdersCount(dashContext.ordersCount + 1);
                    setLoadingSpinner(false);
                    validatorRef.current.hideMessages();
                    forceUpdate()
                    history.push('/dashboard/paymentsuccessfull', {
                        factureNumber: data.factureNumber,
                        DateAndTime: data.dateAndTime,
                        fullName: user.fullName,
                        mobileNumber: user.mobileNumber,
                        transactionPrice: transferType === 'cash' ? price : 0,
                        address: address,
                        telephone: telephone,
                        orderType: 'scrap'
                    })
                }
            }
            else {
                validatorRef.current.showMessages();
                forceUpdate();
            }
        } catch (err) {
            if (err.response && err.response.status === 404) {
                addToast("شماره موبایل و یا کد متخصص قبلا ثبت شده است", {
                    appearance: 'warning',
                    autoDismiss: true,
                })
            }
            else if (err.response && err.response.status === 422) {
                addToast("اطلاعات را کامل وارد کنید", {
                    appearance: 'warning',
                    autoDismiss: true,
                })
            }
            else if(err.response && err.response.status === 401){
                addToast("عدم دسترسی مجاز", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/login');
            }
            setLoadingSpinner(false);
        }
    }

    const fetchUserHandler = async (event) => {
        event.preventDefault();
        try {
            setUserLoading(true);
            let params = userMobileNumber || 'Unknown';
            const { data, status } = await getUserByMobileNumber(params);
            if(status === 201){
                addToast("مشتری مورد نظر تأیید و اضافه شد", {
                    appearance: 'success',
                    autoDismiss: true,
                })
                setUser(data.user);
                setAddress(data.user.address ? data.user.address : '')
                setTelephone(data.user.telephone ? data.user.telephone : '');
            }
        } catch (err) {
            if(err.response && err.response.status === 404){
                addToast("مشتری با این شماره موبایل پیدا نشد", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                setUser();
                // history.replace('/login');
            }
        }
        setUserLoading(false);
    }



    
    return ( 
        <React.Fragment>
            <div className="">
                <header >
                    <h5 className="font-weight-bold ">فاکتور</h5>
                </header>
                <section className="d-flex flex-wrap justify-content-around mb-4">
                    <div>
                        <form onSubmit={fetchUserHandler}>
                            <div className="form-row align-items-end mt-3">
                                <div className="form-group mx-1 mb-2">
                                    <label htmlFor="ucode">
                                    موبایل مشتری را وارد کنید
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{direction:'ltr', textAlign: 'left', width:'130px'}}
                                        id="ucode"
                                        value={userMobileNumber}
                                        onChange={(e) => setUserMobileNumber(digitsFaToEn(digitsArToEn(e.target.value)))}
                                        placeholder=""
                                    />
                                </div>
                                <button
                                    className="btn btn-success mb-2  ml-2"
                                    type="submit"
                                    disabled={userLoading}
                                >
                                    <i 
                                        className={userLoading ? 'spinner-border spinner-border-sm mr-2': ''} 
                                        style={{position:'relative', bottom:'2px'}}
                                    ></i>
                                    جستجو
                                </button>
                            </div>
                        </form>
                        <div >
                            {
                                user &&
                                <Collapse
                                    in={user ? true : false}
                                >
                                    <div>
                                        <div className="image-user-confirm">
                                        </div>
                                        <div>
                                            <small className="font-weight-bold">
                                                <span >نام و نام خانوادگی</span>
                                                <span className="mx-1">:</span>
                                                <span className="text-muted">{user.fullName}</span>
                                            </small>
                                        </div>
                                        <div>
                                            <small className="font-weight-bold">
                                                <span >شماره موبایل</span>
                                                <span className="mx-1">:</span>
                                                <span className="text-muted">{user.mobileNumber}</span>
                                            </small>
                                        </div>
                                        <div>
                                            <small className="font-weight-bold">
                                                <span >کیف پول</span>
                                                <span className="mx-1">:</span>
                                                <span className="text-success">{priceFormat(user.wallet)}</span>
                                                <span className="ml-1 text-success">تومان</span>
                                            </small>
                                        </div>
                                    </div>
                                </Collapse>
                            }
                        </div>
                    </div>
                </section>
                <section>
                    <form onSubmit={submitHandler}>
                        <fieldset disabled={!user}>
                            <section >
                                <div className="d-flex flex-wrap justify-content-between">
                                    <div className="form-group col-sm-6 align-self-center px-1">
                                        <label htmlFor="exampleFormControlTextarea5">
                                            توضیحات معامله
                                        </label>
                                        <textarea
                                            className="form-control"
                                            id="exampleFormControlTextarea5"
                                            rows="4"
                                            placeholder="در حد چند جمله توضیح دهید"
                                            value={description}
                                            name="description"
                                            aria-describedby="description"
                                            onChange={ e => setDescription(e.target.value)}
                                            onBlur={() => {
                                                if (description !== '') {
                                                    validatorRef.current.showMessageFor("description");
                                                    forceUpdate();
                                                }
                                            }}
                                        ></textarea>
                                        {validatorRef.current.message(
                                            "description",
                                            description,
                                            "required|min:15"
                                        )}
                                    </div>
                                    <div className="form-group col-sm-6 align-self-center px-1">
                                        <label htmlFor="exampleFormControlTextarea6">
                                            آدرس مشتری
                                        </label>
                                        <textarea
                                            className="form-control"
                                            id="exampleFormControlTextarea6"
                                            rows="4"
                                            placeholder="آدرس"
                                            value={address}
                                            name="address"
                                            aria-describedby="description"
                                            onChange={ e => setAddress(e.target.value)}
                                            onBlur={() => {
                                                if (address !== '') {
                                                    validatorRef.current.showMessageFor("address");
                                                    forceUpdate();
                                                }
                                            }}
                                        ></textarea>
                                        {validatorRef.current.message(
                                            "address",
                                            address,
                                            "required|min:15"
                                        )}
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-group col-sm-6">
                                        <label htmlFor="uesrTell">تلفن ثابت مشتری</label>
                                        <input
                                            type="text"
                                            className="form-control ltr"
                                            id="uesrTell"
                                            placeholder="0513"
                                            value={telephone}
                                            onChange={(e) => setTelephone(digitsFaToEn(digitsArToEn(e.target.value)))}
                                            onBlur={() => {
                                                if (telephone !== '') {
                                                    validatorRef.current.showMessageFor("telephone");
                                                    forceUpdate();
                                                }
                                            }}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                        />
                                        {validatorRef.current.message(
                                            "telephone",
                                            telephone,
                                            "required|phone"
                                        )}
                                    </div>
                                    <div className="form-group col-sm-6">
                                        <label htmlFor="price">مبلغ پروژه</label>
                                        <input
                                            type="text"
                                            className="form-control ltr"
                                            id="price"
                                            placeholder="تومان"
                                            value={price}
                                            onChange={e => setPrice(digitsFaToEn(digitsArToEn(e.target.value)))}
                                            onBlur={() => {
                                                if (price !== '') {
                                                    validatorRef.current.showMessageFor("price");
                                                    forceUpdate();
                                                }
                                            }}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                        />
                                        {validatorRef.current.message(
                                            "price",
                                            price,
                                            "required|numeric"
                                        )}
                                    </div>
                                </div>
                                <h5 className=" text-success text-center">
                                    {priceFormat(price)} تومان
                                </h5>
                                <div className="my-3 text-center text-sm-left">
                                <h5 className="font-weight-bold my-2">
                                    نوع پرداخت
                                </h5>
                                <ButtonGroup aria-label="Basic example" className="text-center">
                                    <Button 
                                        style={{width:'110px'}}    
                                        variant={transferType === 'wallet' ? 'success' : 'secondary'}
                                        onClick={() => setTransferType('wallet')}
                                    >
                                        <i className="fa fa-shopping-bag mr-2"></i>
                                         کیف پول
                                    </Button>
                                    <Button 
                                        style={{width:'110px'}}
                                        variant={transferType === 'cash' ? 'success' : 'secondary'}
                                        onClick={() => setTransferType('cash')}
                                    >
                                        <i className="fa fa-credit-card mr-2"></i>
                                        نقدی</Button>
                                </ButtonGroup>
                                </div>
                                <div className="text-center mt-4">
                                    <button 
                                        type="submit"
                                        className="btn btn-success mr-1 "
                                        style={{ width: "100px" }}
                                        disabled={loadingSpinner}
                                    >
                                        <i 
                                            className={loadingSpinner ? 'spinner-border spinner-border-sm mr-2': ''} 
                                            style={{position:'relative', bottom:'2px'}}
                                        ></i>
                                        ثبت
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-danger "
                                        style={{ width: "100px" }}
                                        onClick={() => history.replace('/dashboard/places')}
                                    >
                                        بازگشت
                                    </button>
                                </div>
                            </section>
                        </fieldset>
                    </form>
                </section>
            </div>
        </React.Fragment>
     );
}
 
export default ScrapOrderForm;